const Contact1 = () => {
    return (
        <div>
            <form>
                <h1>Contact Us</h1>
                <input type="text" placeholder="Name" className="border-2 rounded-b-md p-2 mr-2" />
                <input type="text" placeholder="Message" className="border-2 rounded-b-md p-2 mr-2" />
                <button className="border-2 rounded-b-md p-2 mr-2">Submit</button>
            </form>
        </div>
    );
};

export default Contact1;
